import { FC } from 'react';
import {
  ChatSocketMessageType,
  IChatMessage,
  MessageFeedback,
} from '../../../schemas/agent-conversation.schema';
import { BotMessage } from './BotMessage';
import { FeedbackProps } from './FeedbackButtons';
import { UserMessage } from './UserMessage';

export interface MessageData extends Pick<IChatMessage, 'content' | 'conversation_id'> {
  id: string | number; // ids generated on the UI are strings (with UiGeneratedIdPrefix), persisted messages have numerical ids
  // Stable React key for the message. `id` flips from a UI-generated string to a server-assigned
  // numeric id when streaming completes; using it as a key remounts the message subtree and
  // briefly shrinks the scrollable container, which clamps scrollTop and looks like a viewport
  // jump back to the question. clientKey is assigned once and never changes.
  clientKey: string;
  isUser: boolean;
  timestamp?: Date;
  type: ChatSocketMessageType;
  feedback?: MessageFeedback;
  // Server-side id of the row this bubble renders: the stream's placeholder id
  // while streaming, swapped for the persisted row's id on complete. WS frames
  // are routed to bubbles by this id; absent when the agent predates the
  // FD-4131 identity contract (last-bubble fallbacks apply).
  serverMessageId?: number;
  // Originating agent for out-of-band pushes (e.g. 'atlas' digests); unset for
  // the chat agent's own replies.
  source?: string;
}

interface MessageProps {
  content: string;
  isUser: boolean;
  animate?: boolean;
  feedbackProps?: FeedbackProps;
}

export const Message: FC<MessageProps> = ({ content, isUser, animate = false, feedbackProps }) => {
  if (isUser) {
    return <UserMessage content={content} />;
  }

  return <BotMessage content={content} animate={animate} feedbackProps={feedbackProps} />;
};
